(() => {
  const initialized = new WeakSet();
  function init(root = document) {
  root.querySelectorAll('[data-reel-carousel]').forEach(carousel => {
    if (initialized.has(carousel)) return;
    initialized.add(carousel);
    const viewport = carousel.querySelector('[data-reel-viewport]');
    // Always start at the first video, however wide the window is or however it was resized
    if (viewport) {
      viewport.style.overflowAnchor = 'none';
      // On phones the row is centred on its middle video by mobile-centre-rows.js instead
      const toStart = () => { if (matchMedia('(max-width: 749px)').matches) return; if (viewport.scrollLeft !== 0) viewport.scrollLeft = 0; };
      toStart();
      requestAnimationFrame(toStart);
      window.addEventListener('load', () => { toStart(); setTimeout(toStart, 400); }, { once: true });
    }    const lightbox = carousel.querySelector('[data-reel-lightbox]');
    let lightboxMedia = carousel.querySelector('[data-reel-lightbox-media]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const videos = [...carousel.querySelectorAll('.social-reel video')];
    const onScreen = new Set();
    const syncVideos = () => videos.forEach(video => {
      if (onScreen.has(video) && !reduced.matches && !document.hidden && !lightbox?.open) video.play().catch(() => {});
      else video.pause();
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) onScreen.add(entry.target); else onScreen.delete(entry.target); });
      syncVideos();
    }, { threshold: .25 });
    videos.forEach(video => { video.preload = 'metadata'; video.autoplay = false; observer.observe(video); });
    // Buffer a video before it's scrolled into view, not only once it's already visible, so playback doesn't stall mid-swipe
    const preloadObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.preload = 'auto'; preloadObserver.unobserve(entry.target); } });
    }, { rootMargin: '0px 600px 0px 600px', threshold: 0 });
    videos.forEach(video => preloadObserver.observe(video));
    const visibility = () => { if (!carousel.isConnected) { observer.disconnect(); document.removeEventListener('visibilitychange', visibility); return; } syncVideos(); };
    document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', syncVideos);
    // Arrows move one video at a time; on phones the next video lands in the centre
    const move = direction => {
      if (!viewport) return;
      const cards = [...carousel.querySelectorAll('.social-reel')];
      const box = viewport.getBoundingClientRect();
      const phone = matchMedia('(max-width: 749px)').matches;
      const centres = cards.map(card => { const r = card.getBoundingClientRect(); return r.left - box.left + viewport.scrollLeft + r.width / 2; });
      const nearest = centres.reduce((best, c, k) => (Math.abs(c - viewport.scrollLeft - box.width / 2) < Math.abs(centres[best] - viewport.scrollLeft - box.width / 2) ? k : best), 0);
      const gap = parseFloat(getComputedStyle(carousel.querySelector('.social-reels__track')).gap) || 0;
      const step = (cards[0]?.getBoundingClientRect().width || 280) + gap;
      const target = phone
        ? centres[Math.min(cards.length - 1, Math.max(0, nearest + direction))] - box.width / 2
        : viewport.scrollLeft + direction * step;
      const from = viewport.scrollLeft;
      viewport.scrollTo({ left: target, behavior: reduced.matches ? 'instant' : 'smooth' });
      // Some browsers drop a smooth scroll on a snapping row: jump there instead
      setTimeout(() => { if (Math.abs(viewport.scrollLeft - from) < 2) viewport.scrollLeft = target; }, 450);
    };
    let origin, startX = 0, startY = 0, swiped = false, scrollBefore = '';
    viewport?.addEventListener('pointerdown', e => { startX = e.clientX; startY = e.clientY; swiped = false; });
    viewport?.addEventListener('pointermove', e => { if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) swiped = true; });
    // Dim an arrow when there is nothing further in its direction; hide both when everything already fits
    const updateArrows = () => {
      if (!viewport) return;
      const overflow = viewport.scrollWidth - viewport.clientWidth;
      const max = overflow - 2;
      carousel.querySelectorAll('[data-reel-move]').forEach(button => {
        button.hidden = overflow <= 4;
        button.disabled = Number(button.dataset.reelMove) < 0 ? viewport.scrollLeft <= 2 : viewport.scrollLeft >= max;
      });
    };
    viewport?.addEventListener('scroll', updateArrows, { passive: true });
    const reelTrack = carousel.querySelector('.social-reels__track');
    if (window.ResizeObserver && viewport) { const resizeArrows = new ResizeObserver(updateArrows); resizeArrows.observe(viewport); if (reelTrack) resizeArrows.observe(reelTrack); }
    if (window.MutationObserver && reelTrack) new MutationObserver(updateArrows).observe(reelTrack, { childList: true });
    window.addEventListener('load', updateArrows, { once: true });
    updateArrows();
    carousel.querySelectorAll('[data-reel-move]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.reelMove))));
    viewport?.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); } });
    // Story mode: a progress segment per reel, fills as its video plays, advances to the next on end
    const reels = [...carousel.querySelectorAll('.social-reel')];
    const progress = carousel.querySelector('[data-reel-progress]');
    const soundButton = carousel.querySelector('[data-reel-lightbox-sound]');
    const shopLink = carousel.querySelector('[data-reel-lightbox-shop]');
    const shopImage = carousel.querySelector('[data-reel-lightbox-shop-image]');
    const shopTitle = carousel.querySelector('[data-reel-lightbox-shop-title]');
    const shopPrice = carousel.querySelector('[data-reel-lightbox-shop-price]');
    const shopUrl = carousel.dataset.reelShopUrl;
    const strip = lightboxMedia?.parentElement;
    let current = 0;
    let lightboxMuted = true;

    if (shopLink && shopUrl) {
      shopLink.href = shopUrl;
      shopLink.hidden = false;
      if (shopImage) shopImage.src = carousel.dataset.reelShopImage || '';
      if (shopTitle) shopTitle.textContent = carousel.dataset.reelShopTitle || '';
      if (shopPrice) shopPrice.textContent = carousel.dataset.reelShopPrice || '';
    }

    const buildProgress = () => {
      if (!progress) return;
      progress.replaceChildren(...reels.map(() => {
        const seg = document.createElement('span');
        seg.className = 'reel-lightbox__progress-seg';
        seg.innerHTML = '<i></i>';
        return seg;
      }));
    };
    const setProgressState = index => {
      if (!progress) return;
      [...progress.children].forEach((seg, i) => {
        seg.classList.toggle('is-done', i < index);
        seg.classList.toggle('is-active', i === index);
        const fill = seg.querySelector('i');
        if (fill && i !== index) fill.style.width = i < index ? '100%' : '0%';
      });
    };

    // Peeking neighbour slides either side of the active video, like mikeshothoney.com's story viewer
    const peekEls = {
      '-1': carousel.querySelector('[data-reel-lightbox-peek="-1"]'),
      '1': carousel.querySelector('[data-reel-lightbox-peek="1"]')
    };
    const setPeekClick = (el, d) => { el.onclick = () => showReel(current + d, d); };
    const fillPeek = (el, dir) => {
      if (!el) return;
      el.replaceChildren();
      if (reels.length < 2) return;
      const index = (current + dir + reels.length) % reels.length;
      const source = reels[index].querySelector('video, img');
      if (!source) return;
      const media = source.cloneNode(true);
      media.removeAttribute('class');
      if (media.tagName === 'VIDEO') { media.removeAttribute('autoplay'); media.muted = true; media.controls = false; media.autoplay = false; media.loop = true; media.play().catch(() => {}); }
      el.appendChild(media);
      setPeekClick(el, dir);
    };
    const bindPlayback = media => {
      if (media.tagName !== 'VIDEO' || media.dataset.bound) return;
      media.dataset.bound = '1';
      media.addEventListener('timeupdate', () => {
        if (media.parentElement !== lightboxMedia) return;
        const fill = progress?.children[current]?.querySelector('i');
        if (fill && media.duration) fill.style.width = `${(media.currentTime / media.duration) * 100}%`;
      });
      media.addEventListener('ended', () => { if (media.parentElement !== lightboxMedia) return; if (current < reels.length - 1) showReel(current + 1, 1); else closeLightbox(); });
    };
    const setRole = (el, role) => {
      el.classList.toggle('reel-lightbox__slide--current', role === 'current');
      el.classList.toggle('reel-lightbox__slide--peek', role === 'peek');
    };
    // All three slots are the same size and only move/scale, so a swipe never resizes or re-lays-out anything.
    // Sizes mirror the CSS (current 86.7dvh max 780px; side 52vh max 468px, 30vh max 200px on phones).
    const metrics = () => {
      const mobile = window.innerWidth <= 600;
      const curH = Math.min(0.867 * window.innerHeight, 780);
      const peekH = mobile ? Math.min(0.3 * window.innerHeight, 200) : Math.min(0.52 * window.innerHeight, 468);
      const gap = mobile ? 16 : Math.min(Math.max(0.1 * window.innerWidth, 40), 152);
      const k = peekH / curH, w = curH * 9 / 16;
      return { k, x: w / 2 + gap + k * w / 2 };
    };
    const slotAt = pos => (pos === 0 ? lightboxMedia : peekEls[String(pos)]);
    const place = (el, pos, dx = 0) => {
      if (!el) return;
      const { k, x } = metrics();
      const cd = Math.max(-x, Math.min(x, dx));
      const t = Math.abs(cd) / x;
      const incoming = dx ? -Math.sign(dx) : 0;
      const s = pos === 0 ? 1 - (1 - k) * t : pos === incoming ? k + (1 - k) * t : k;
      el.style.transform = `translate(-50%,-50%) translateX(${pos * x + cd}px) scale(${s})`;
      el.style.zIndex = pos === 0 ? 2 : 1;
    };
    const layout = (dx = 0) => [-1, 0, 1].forEach(pos => place(slotAt(pos), pos, dx));

    // dir is +1/-1 when stepping to a neighbour: the slots swap places by sliding, no video is moved or reloaded
    const showReel = (index, dir = 0) => {
      if (!lightbox || !lightboxMedia || !reels.length) return;
      const rotate = Math.abs(dir) === 1 && reels.length > 2 && peekEls[String(dir)]?.firstElementChild;
      current = (index + reels.length) % reels.length;
      const reel = reels[current];
      origin = origin || reel;
      let media;
      if (rotate) {
        const incoming = peekEls[String(dir)], outgoing = lightboxMedia, far = peekEls[String(-dir)];
        lightboxMedia = incoming;
        peekEls[String(-dir)] = outgoing;
        peekEls[String(dir)] = far;
        setRole(incoming, 'current');
        setRole(outgoing, 'peek');
        setRole(far, 'peek');
        setPeekClick(outgoing, -dir);
        const outVideo = outgoing.querySelector('video');
        if (outVideo) outVideo.loop = true;
        media = incoming.firstElementChild;
        if (media.tagName === 'VIDEO') media.currentTime = 0;
        // the far slot jumps to the other side unseen, loads the next video and fades in
        far.style.transition = 'none';
        far.style.opacity = '0';
        fillPeek(far, dir);
        place(far, dir);
        void far.offsetWidth;
        far.style.transition = '';
        far.style.opacity = '';
        place(incoming, 0);
        place(outgoing, -dir);
      } else {
        const source = reel.querySelector('video, img');
        if (!source) return;
        media = source.cloneNode(true);
        media.removeAttribute('class');
        lightboxMedia.replaceChildren(media);
        fillPeek(peekEls['-1'], -1);
        fillPeek(peekEls['1'], 1);
        strip?.classList.add('is-dragging');
        layout();
        requestAnimationFrame(() => requestAnimationFrame(() => strip?.classList.remove('is-dragging')));
      }
      if (media.tagName === 'VIDEO') {
        media.muted = lightboxMuted;
        media.controls = false;
        media.autoplay = true;
        media.loop = false;
        bindPlayback(media);
      }
      setProgressState(current);
      if (soundButton) { soundButton.setAttribute('aria-pressed', String(!lightboxMuted)); soundButton.setAttribute('aria-label', lightboxMuted ? 'Turn sound on' : 'Turn sound off'); soundButton.textContent = lightboxMuted ? '⌁' : '♪'; }
      carousel.querySelectorAll('[data-reel-lightbox-move]').forEach(button => { button.disabled = reels.length < 2; });
      if (media.tagName === 'VIDEO') media.play().catch(() => {});
    };

    const openLightbox = reel => {
      if (!lightbox || !lightboxMedia) return;
      buildProgress();
      origin = reel;
      scrollBefore = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      lightbox.showModal();
      syncVideos();
      showReel(reels.indexOf(reel));
    };
    reels.forEach(reel => {
      reel.addEventListener('click', () => { if (!swiped) openLightbox(reel); });
      reel.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openLightbox(reel); } });
    });
    const closeLightbox = () => { lightboxMedia?.replaceChildren(); Object.values(peekEls).forEach(el => el?.replaceChildren()); lightbox?.close(); };
    carousel.querySelector('[data-reel-lightbox-close]')?.addEventListener('click', closeLightbox);
    carousel.querySelectorAll('[data-reel-lightbox-move]').forEach(button => button.addEventListener('click', () => showReel(current + Number(button.dataset.reelLightboxMove), Number(button.dataset.reelLightboxMove))));
    soundButton?.addEventListener('click', () => {
      lightboxMuted = !lightboxMuted;
      const media = lightboxMedia.querySelector('video');
      if (media) { media.muted = lightboxMuted; if (!lightboxMuted) media.play().catch(() => {}); }
      soundButton.setAttribute('aria-pressed', String(!lightboxMuted));
      soundButton.setAttribute('aria-label', lightboxMuted ? 'Turn sound on' : 'Turn sound off');
      soundButton.textContent = lightboxMuted ? '⌁' : '♪';
    });
    // Swipe: the slots follow the finger, then settle on the next or previous video
    let lbStartX = 0, lbStartY = 0, lbDx = 0, lbSwiped = false, lbDragging = false;
    lightbox?.addEventListener('pointerdown', event => { lbStartX = event.clientX; lbStartY = event.clientY; lbDx = 0; lbSwiped = false; lbDragging = true; strip?.classList.add('is-dragging'); });
    lightbox?.addEventListener('pointermove', event => {
      if (!lbDragging) return;
      lbDx = event.clientX - lbStartX;
      if (Math.abs(lbDx) > 10 && Math.abs(lbDx) > Math.abs(event.clientY - lbStartY)) lbSwiped = true;
      if (lbSwiped) layout(lbDx);
    });
    const endDrag = () => {
      if (!lbDragging) return;
      lbDragging = false;
      strip?.classList.remove('is-dragging');
      if (!lbSwiped || Math.abs(lbDx) < 50 || reels.length < 2) { layout(); return; }
      const dir = lbDx < 0 ? 1 : -1;
      showReel(current + dir, dir);
    };
    lightbox?.addEventListener('pointerup', endDrag);
    lightbox?.addEventListener('pointercancel', endDrag);
    lightbox?.addEventListener('click', event => { if (lbSwiped) { event.stopPropagation(); event.preventDefault(); lbSwiped = false; } }, true);
    lightbox?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') showReel(current - 1, -1);
      else if (event.key === 'ArrowRight') showReel(current + 1, 1);
    });
    lightbox?.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
    lightbox?.addEventListener('close', () => { lightboxMedia?.replaceChildren(); document.documentElement.style.overflow = scrollBefore; origin?.focus({ preventScroll: true }); origin = null; syncVideos(); });
    carousel.querySelectorAll('[data-reel-sound]').forEach(button => button.addEventListener('click', () => { const video = button.parentElement.querySelector('video'); if (!video) return; video.muted = !video.muted; button.setAttribute('aria-pressed', String(!video.muted)); button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off'); button.textContent = video.muted ? '⌁' : '♪'; if (!video.muted) video.play().catch(() => {}); }));
  });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
